// src/components/NavBar.jsx

import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";

import jwt_decode from "jwt-decode";

import {
  Navbar,
  Nav,
  Container,
} from "react-bootstrap";

import {
  FaTruck,
  FaShieldAlt,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaFileInvoiceDollar,
  FaUserPlus,
  FaChartBar,
  FaInfoCircle,
  FaUser,
  FaChevronDown,
} from "react-icons/fa";

import logo from "../images/DANLU_logo_transparent.png";
import iconPapas from "../images/bolsa.png";
import iconPeaje from "../images/peaje.png";

import "../css/navbar.css";

export default function NavBar() {
  const location =
    useLocation();

  const history =
    useHistory();

  const [
    user,
    setUser,
  ] = useState(
    "Iniciar sesión"
  );

  const [
    role,
    setRole,
  ] = useState("");

  useEffect(() => {
    const usuarioLS =
      JSON.parse(
        localStorage.getItem(
          "usuario"
        )
      );

    setUser(
      usuarioLS ||
        "Iniciar sesión"
    );

    const token =
      localStorage.getItem(
        "token"
      ) || "";

    try {
      if (token) {
        const {
          usuario,
        } = jwt_decode(
          token
        );

        setRole(
          usuario.role
        );
      }
    } catch {
      setRole("");
    }
  }, [location]);

  const handleLogout = () => {
    [
      "token",
      "id",
      "usuario",
    ].forEach(
      (k) =>
        localStorage.removeItem(
          k
        )
    );

    setRole("");

    setUser(
      "Iniciar sesión"
    );

    history.push(
      "/login"
    );
  };

  /* =======================================================
     LINKS
  ======================================================= */

  const adminLinks = [
    {
      label: "Viajes",
      to: "/Comandas",
      reactIcon: FaTruck,

      paths: [
        "/comandas",
      ],
    },

    {
      label: "Papas",
      to: "/Remitos",
      icon: iconPapas,

      paths: [
        "/remitos",
      ],
    },

    {
      label: "Peajes",
      to: "/peajes",
      icon: iconPeaje,

      paths: [
        "/peajes",
        "/importarpeajes",
        "/resumenespeajes",
        "/informepeajes",
      ],
    },

    {
      label: "Seguros",
      to: "/seguros",
      reactIcon:
        FaShieldAlt,

      paths: [
        "/seguros",
        "/polizasseguros",
        "/informeseguros",
      ],
    },

    {
      label: "Cajas",
      to: "/Cajas",
      reactIcon:
        FaMoneyBillWave,

      paths: [
        "/cajas",
      ],
    },

    {
      label: "Movimientos",
      to: "/Movimientos",
      reactIcon:
        FaExchangeAlt,

      paths: [
        "/movimientos",
      ],
    },

    {
      label: "Rendiciones",
      to: "/Viajes",
      reactIcon:
        FaFileInvoiceDollar,

      paths: [
        "/viajes",
      ],
    },

    {
      label: "Altas",
      to: "/HomeAltas",
      reactIcon:
        FaUserPlus,

      paths: [
        "/homealtas",
      ],
    },

    {
      label: "Informes",
      to: "/HomeImpresion",
      reactIcon:
        FaChartBar,

      paths: [
        "/homeimpresion",
      ],
    },

    {
      label: "Acerca de",
      to: "/AcercaDe",
      reactIcon:
        FaInfoCircle,

      paths: [
        "/acercade",
      ],
    },
  ];

  /* =======================================================
     ACTIVO
  ======================================================= */

  const pathActual =
    location.pathname.toLowerCase();

  const esLogin =
    pathActual === "/login";

  const linkActivo = (
    item
  ) =>
    (
      item.paths || [
        item.to,
      ]
    ).some(
      (path) =>
        pathActual ===
        path.toLowerCase()
    );

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className="danlu-navbar-wrapper">
      <Container
        fluid
        className="danlu-navbar-container"
      >
        <Navbar
          expand="lg"
          sticky="top"
          className="danlu-navbar"
        >
          {/* LOGO */}

          <Navbar.Brand
            as={Link}
            to="/"
            className="danlu-navbar-brand"
          >
            <img
              src={logo}
              alt="DANLU"
              className="danlu-navbar-logo"
            />

            <span className="danlu-navbar-title">
              TRANSPORTE DANLU
            </span>
          </Navbar.Brand>

          {!esLogin && (
            <>
              <Navbar.Toggle
                aria-controls="danlu-nav"
                className="danlu-navbar-toggle"
              />

              <Navbar.Collapse
                id="danlu-nav"
              >
                {/* LINKS */}

                <Nav className="danlu-navbar-links">
                  {role.startsWith(
                    "ADMIN"
                  ) &&
                    adminLinks.map(
                      ({
                        label,
                        to,
                        icon,
                        reactIcon:
                          ReactIcon,
                        ...item
                      }) => {
                        const activo =
                          linkActivo({
                            to,
                            ...item,
                          });

                        return (
                          <Nav.Link
                            as={Link}
                            key={to}
                            to={to}
                            className={`danlu-nav-link ${
                              activo
                                ? "active"
                                : ""
                            }`}
                          >
                            <span className="danlu-nav-icon">
                              {icon && (
                                <img
                                  src={icon}
                                  alt={label}
                                />
                              )}

                              {ReactIcon && (
                                <ReactIcon />
                              )}
                            </span>

                            <span className="danlu-nav-label">
                              {label}
                            </span>
                          </Nav.Link>
                        );
                      }
                    )}
                </Nav>

                {/* USUARIO */}

                <button
                  type="button"
                  className="danlu-user-button"
                  onClick={
                    handleLogout
                  }
                  title="Cerrar sesión"
                >
                  <FaUser className="danlu-user-icon" />

                  <span className="danlu-user-name">
                    {user}
                  </span>

                  <FaChevronDown className="danlu-user-chevron" />
                </button>
              </Navbar.Collapse>
            </>
          )}
        </Navbar>
      </Container>
    </div>
  );
}